import { useNavigate } from "react-router-dom"
import WizrTable from "../components/WizrTable";
import WizrFlexLayout from "../components/WizrFlexLayout";
import { styled } from "styled-components";
import WizrText from "../components/WizrText";
import WizrButton from "../components/WizrButton";
import WizrUserJourney from "../components/WizrUserJourney";
import CreateNew from "../assets/icons/CreateNew";
import { MODAL_TYPES, useWizrModalContext } from "../providers/modal/WizrModalProvider";
import { useEffect, useRef, useState } from "react";
import { dispatchlistScheduler } from "../redux/actions/content";
import { useInnerContentLoadingSelector, useListSchedulerSelectors } from "../redux/selectors/content";
import { PaginationLimit } from "../utils";
import { Spin } from "antd";

const StyledWizrTable = styled(WizrTable)`
  .ant-table-wrapper {
    width: 100% !important;
  }
  .ant-table-thead {
    background-color: #f2f4f9;
    border-spacing: 0px;
  }
  .ant-table-tbody > tr {
    background-color: #ffffff;
    margin-bottom: 0px;
  }

  .ant-table table {
    border-spacing: 0 5px;
  }
  .ant-table-tbody td,
  .ant-table-thead th {
    padding: 8px !important; /* Ensures the padding is applied */
  }

`
interface TableData {
  name: string;
  tool: string;
  integration: string;
  emailaddress: string;
  repeated: string;
  date_range: {
    start: string;
    end: string;
  };
  last_run: string;
}

const Scheduler = () => {

  const [tableData, setTableData] = useState<TableData[]>([]);
  const listInnerRef = useRef<HTMLDivElement | null>(null);
  const [currPage, setCurrPage] = useState(1);
  const innerContentLoading = useInnerContentLoadingSelector();
  console.log("innerContentLoading",innerContentLoading);

  const schedulerListing =  useListSchedulerSelectors()
  const schedulerListingData = schedulerListing
  console.log("schedulerListing",schedulerListing)
  // console.log("schedulerListingData",schedulerListingData)
  

  useEffect(() => {
    if (schedulerListingData) {
      const formattedData = schedulerListingData.map((item: any) => ({
      }
    ));
      setTableData(schedulerListingData);
      console.log("Formatted data:", formattedData); 
    }
  }, [schedulerListingData]);

  const [pagination, setPagination] = useState({
    limit: PaginationLimit,
    offset: 0
  });

  useEffect(() => {
    const payload = {
      offset: 0,
      limit: PaginationLimit
    };
    setPagination(payload);
    dispatchlistScheduler(payload,false)
  }, [])
  const onScroll = () => {
    console.log("innerContentLoading inside");
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

      if (Math.abs(scrollTop + clientHeight - scrollHeight) <= 2 && !innerContentLoading) {
        console.log("if inside");
        const current = currPage;
        setCurrPage(currPage + 1);
        
        const payload = {
          offset: current * PaginationLimit,
          limit: PaginationLimit
         
        };
        console.log("payload",payload);
        dispatchlistScheduler(payload,true);
      }
    }
  };

  



    const navigate = useNavigate()
    const { showModal, hideModal } = useWizrModalContext()
    const onAddSchedule = () => {
      showModal(MODAL_TYPES.ADD_SCHEDULE, {
          onFormSubmission: async ({data}: any) => {
              // Update table immediately with formatted data
              // setTableData(prevData => [...prevData, data]);
              hideModal();
          },
          onCancel: hideModal
      });
  };

  console.log('table',tableData)

    return (
        <WizrFlexLayout>
        <WizrFlexLayout justifyContent='space-between' alignItems='center' flexDirection='row' flex={1.4}>
        <WizrUserJourney
          userJourney={[
            {
              title: (
                <WizrButton
                  padding='0px'
                  type='text'
                  text={
                      <WizrText type="h6" textColor="#707276">Past Ticket</WizrText>
                  }
                  onClick={() => navigate(-1)} // Navigate back to the previous page
                />
              ),
              isCurrent: false,
            },
            {
              title: (
                <WizrText type='h6'>Scheduler</WizrText> // Current page
              ),
              isCurrent: true,
            },
          ]}
        />
        <WizrButton 
          type="primary" 
          icon={<CreateNew fill={'white'}/>} 
          style={{marginTop:"10px",borderRadius:"25px"}} 
          text={<WizrText type='button'>{`Add Schedule `}</WizrText>}
          onClick={()=>{
            onAddSchedule()
          }}
          > 
        </WizrButton>
      </WizrFlexLayout>  
      <WizrFlexLayout flex={11}>
      <div onScroll={onScroll} ref={listInnerRef} style={{ height: '100vh', overflowY: 'auto' }}>
        <StyledWizrTable type='scheduler'  dataSource={tableData} pagination={false}/>
        {innerContentLoading && schedulerListing?.length !== 0 && (
          <WizrFlexLayout
            background='#FFF'
            justifyContent='center'
            textAlign='center'
            style={{ padding: '20px' }}
          >
            <Spin />
          </WizrFlexLayout>
        )}
      </div>
      
      </WizrFlexLayout>
      </WizrFlexLayout>
    );
  };
  
  export default Scheduler;